import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/app/(pages)/case-studies/page.tsx");
